import { FormEditTabType, getWebPath } from '@doss/common-all'
import { RxPlus } from 'react-icons/rx'
import { useNavigate } from 'react-router'
import { BreadcrumbObjectType, useCreateFormV2Mutation } from '~/common/generated/apollo-operations'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { Button } from '../ui/atoms/button/Button'

/**
 *  Add new form button in the forms home page.
 */
export function AddNewFormButton() {
  const navigate = useNavigate()
  const { t } = useTypedTranslation()

  const [createFormV2] = useCreateFormV2Mutation()

  const handleFormV2Click = async () => {
    const result = await createFormV2()
    if (result.data?.createFormV2) {
      const path = getWebPath({
        objectType: BreadcrumbObjectType.FORM,
        objectId: result.data.createFormV2.id,
        settings: true,
        settingsParams: {
          tab: FormEditTabType.FORM_CONTENT,
        },
      })
      navigate(path)
    }
  }

  return (
    <div className="flex gap-2 py-3 text-xs">
      <Button
        className="!text-xs"
        onClick={handleFormV2Click}
        startIcon={<RxPlus />}
        variant="primary"
      >
        {t('form.add_new_form')}
      </Button>
    </div>
  )
}
